// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sr-page {
  min-height: 100vh;
  background: var(--bg);
}

/* Header */
.sr-header {
  background: #fff;
  border-bottom: 1px solid var(--border);
  padding: 20px 20px;
  position: sticky;
  top: 64px;
  z-index: 50;
}

.sr-header-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 12px;
}

.sr-back {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid var(--border);
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--text);
  flex-shrink: 0;
  transition: background 0.2s;
  text-decoration: none;
}
.sr-back:hover { background: var(--bg); }

.sr-search-bar {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 10px;
  background: #f3f4f6;
  border: 1.5px solid var(--border);
  border-radius: 12px;
  padding: 8px 10px 8px 14px;
  transition: border-color 0.2s;
  max-width: 560px;
}
.sr-search-bar:focus-within {
  border-color: var(--p1);
  background: #fff;
}
.sr-search-bar svg { color: var(--muted2); flex-shrink: 0; }
.sr-search-bar input {
  flex: 1 1;
  border: none;
  background: transparent;
  font-size: 0.95rem;
  font-family: inherit;
  color: var(--text);
  outline: none;
}
.sr-search-bar input::placeholder { color: var(--muted2); }

.sr-search-btn {
  background: var(--grad);
  color: #fff;
  border: none;
  border-radius: 9px;
  padding: 9px 18px;
  font-size: 0.88rem;
  font-weight: 700;
  cursor: pointer;
  font-family: inherit;
  white-space: nowrap;
  transition: opacity 0.2s;
}
.sr-search-btn:hover { opacity: 0.9; }

/* Body */
.sr-body {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 20px 60px;
}

.sr-meta {
  margin-bottom: 24px;
}

.sr-meta-title {
  font-size: 1.3rem;
  font-weight: 800;
  color: var(--text);
  letter-spacing: -0.3px;
}

.sr-meta-sub {
  font-size: 0.85rem;
  color: var(--muted);
  margin-top: 4px;
}

/* Filters row */
.sr-filters {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 28px;
}

.sr-filter-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border: 1.5px solid var(--border);
  border-radius: 20px;
  padding: 6px 14px;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--muted);
  background: #fff;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;
}
.sr-filter-chip:hover, .sr-filter-chip.active {
  border-color: var(--p1);
  color: var(--p1);
}

/* City proximity filter */
.sr-city-filter {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.sr-city-input-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1;
  min-width: 200px;
  background: #fff;
  border: 1.5px solid var(--border);
  border-radius: 10px;
  padding: 0 10px;
  transition: border-color 0.2s;
}
.sr-city-input-wrap:focus-within {
  border-color: var(--p1);
}

.sr-city-icon { color: var(--muted); flex-shrink: 0; }

.sr-city-input {
  flex: 1 1;
  border: none;
  outline: none;
  font-size: 0.9rem;
  color: var(--text);
  background: transparent;
  padding: 10px 0;
  font-family: inherit;
}
.sr-city-input::placeholder { color: var(--muted); }

.sr-city-clear {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--muted);
  display: flex;
  align-items: center;
  padding: 2px;
  border-radius: 50%;
  transition: color 0.15s;
}
.sr-city-clear:hover { color: var(--text); }

.sr-locate-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  border-radius: 10px;
  border: 1.5px solid var(--p1);
  background: #fff;
  color: var(--p1);
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s, color 0.2s;
  font-family: inherit;
}
.sr-locate-btn:hover:not(:disabled) { background: var(--p1); color: #fff; }
.sr-locate-btn:disabled { opacity: 0.6; cursor: not-allowed; }

@keyframes sr-spin { to { transform: rotate(360deg); } }
.sr-spin { animation: sr-spin 0.8s linear infinite; }

/* Grid */
.sr-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 16px;
}

.sr-card {
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  text-decoration: none;
  transition: box-shadow 0.2s, transform 0.15s;
  padding: 0;
  width: 100%;
  text-align: left;
}
.sr-card:focus { outline: none; }
.sr-card:focus-visible { box-shadow: 0 0 0 3px rgba(79,70,229,0.25),0 6px 24px rgba(0,0,0,0.09); }
.sr-card:hover { box-shadow: 0 6px 24px rgba(0,0,0,0.09); transform: translateY(-2px); }

.sr-card-top {
  height: 90px;
  background: linear-gradient(135deg, #eef2ff, #e0e7ff);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.sr-avatar {
  width: 68px;
  height: 68px;
  border-radius: 50%;
  border: 3px solid #fff;
  object-fit: cover;
  position: absolute;
  bottom: -24px;
  left: 20px;
  background: #e0e7ff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
  font-weight: 800;
  color: var(--p1);
}

.sr-card-body {
  padding: 32px 16px 16px;
}

.sr-name {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--text);
  margin-bottom: 2px;
}

.sr-address {
  font-size: 0.78rem;
  color: var(--muted);
  margin-bottom: 10px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.sr-cats {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-bottom: 12px;
}

.sr-cat-tag {
  background: #eef2ff;
  color: var(--p1);
  font-size: 0.72rem;
  font-weight: 700;
  border-radius: 6px;
  padding: 3px 8px;
}

.sr-footer-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid var(--border);
  padding-top: 10px;
}

.sr-rating {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.82rem;
  font-weight: 700;
  color: #f59e0b;
}
.sr-rating span { color: var(--muted); font-weight: 500; }

.sr-done {
  font-size: 0.78rem;
  color: var(--muted);
}
.sr-done strong { color: var(--text); font-weight: 700; }

/* States */
.sr-loading, .sr-empty {
  text-align: center;
  padding: 80px 20px;
  color: var(--muted);
}

.sr-spinner {
  width: 36px;
  height: 36px;
  border: 3px solid var(--border);
  border-top-color: var(--p1);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin: 0 auto 16px;
}
@keyframes spin { to { transform: rotate(360deg); } }

.sr-empty-icon { font-size: 3rem; margin-bottom: 12px; }
.sr-empty-title { font-size: 1.05rem; font-weight: 700; color: var(--text); margin-bottom: 6px; }
.sr-empty-sub { font-size: 0.88rem; }
.sr-empty-cta { margin-top: 24px; }

@media (max-width: 500px) {
  .sr-grid { grid-template-columns: 1fr; }
}

.sr-modal-backdrop{
  position: fixed;
  inset: 0;
  background: rgba(17,24,39,0.55);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 90px 16px 20px;
  z-index: 120;
}
.sr-modal{
  width: min(860px,100%);
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 18px 60px rgba(0,0,0,0.25);
}
.sr-modal-head{
  display:flex;
  align-items:center;
  justify-content:space-between;
  padding:14px 16px;
  border-bottom:1px solid var(--border);
}
.sr-modal-title{font-weight:800;color:var(--text);letter-spacing:-0.2px}
.sr-modal-close{
  width:34px;height:34px;border-radius:10px;
  border:1px solid var(--border);
  background:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;
}
.sr-modal-body{padding:16px}
.sr-modal-hero{display:flex;gap:14px;align-items:flex-start}
.sr-modal-avatar .sr-avatar{
  position: static;
  width: 78px;
  height: 78px;
  border: 2px solid #fff;
  box-shadow: 0 6px 18px rgba(0,0,0,0.12);
}
.sr-modal-hero-meta{flex:1 1}
.sr-modal-address{color:var(--muted);font-size:0.85rem;margin-top:2px}
.sr-modal-stats{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:10px;margin-top:10px}
.sr-modal-stat{
  border:1px solid var(--border);
  border-radius:12px;
  padding:10px;
  display:flex;
  gap:8px;
  align-items:flex-start;
  color:var(--text);
}
.sr-modal-stat svg{color:var(--p1);margin-top:2px}
.sr-modal-stat-v{font-weight:800;line-height:1}
.sr-modal-stat-k{font-size:0.72rem;color:var(--muted);margin-top:3px}
.sr-modal-cats{display:flex;flex-wrap:wrap;gap:6px;margin-top:12px}
.sr-modal-section{margin-top:16px}
.sr-modal-section-title{font-weight:800;color:var(--text);margin-bottom:10px}
.sr-modal-loading,.sr-modal-empty{color:var(--muted);padding:10px 0}
.sr-modal-services{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px}
.sr-modal-service{border:1px solid var(--border);border-radius:12px;padding:12px}
.sr-modal-service-title{font-weight:800;color:var(--text);font-size:0.92rem}
.sr-modal-service-desc{color:var(--muted);font-size:0.82rem;margin-top:4px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}
.sr-modal-service-meta{display:flex;gap:6px;flex-wrap:wrap;margin-top:10px}
.sr-modal-pill{border:1px solid var(--border);border-radius:999px;padding:4px 10px;font-size:0.72rem;color:var(--muted);background:#fff}
.sr-modal-cta{
  display:flex;align-items:center;justify-content:center;
  margin-top:16px;
  height:46px;
  border-radius:12px;
  background:var(--grad);
  color:#fff;
  font-weight:800;
  text-decoration:none;
}
@media (max-width: 760px){
  .sr-modal-stats{grid-template-columns:repeat(2,minmax(0,1fr))}
  .sr-modal-services{grid-template-columns:1fr}
  .sr-modal-backdrop{padding-top:78px}
}
`, "",{"version":3,"sources":["webpack://./src/components/SearchResults.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,2BAA2B;EAC3B,qBAAqB;AACvB;AACA,iBAAiB,qBAAqB,EAAE;;AAExC;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;EACnB,0BAA0B;EAC1B,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;AACA,qBAAqB,oBAAoB,EAAE,cAAc,EAAE;AAC3D;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;AACf;AACA,oCAAoC,oBAAoB,EAAE;;AAE1D;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;AAC1B;AACA,uBAAuB,YAAY,EAAE;;AAErC,SAAS;AACT;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yCAAyC;AAC3C;AACA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,uBAAuB;AACzB;;AAEA,gBAAgB,mBAAmB,EAAE,cAAc,EAAE;;AAErD;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;AACA,8BAA8B,mBAAmB,EAAE;;AAEnD;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;AACzB;AACA,uBAAuB,kBAAkB,EAAE;;AAE3C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,uCAAuC;EACvC,oBAAoB;AACtB;AACA,sCAAsC,qBAAqB,EAAE,WAAW,EAAE;AAC1E,0BAA0B,YAAY,EAAE,mBAAmB,EAAE;;AAE7D,qBAAqB,KAAK,yBAAyB,EAAE,EAAE;AACvD,WAAW,uCAAuC,EAAE;;AAEpD,SAAS;AACT;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,4CAA4C;EAC5C,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;AACA,iBAAiB,aAAa,EAAE;AAChC,yBAAyB,sEAAsE,EAAE;AACjG,iBAAiB,uCAAuC,EAAE,2BAA2B,EAAE;;AAEvF;EACE,YAAY;EACZ,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA,kBAAkB,mBAAmB,EAAE,gBAAgB,EAAE;;AAEzD;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA,kBAAkB,kBAAkB,EAAE,gBAAgB,EAAE;;AAExD,WAAW;AACX;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,2BAA2B;EAC3B,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;AACrB;AACA,kBAAkB,KAAK,yBAAyB,EAAE,EAAE;;AAEpD,iBAAiB,eAAe,EAAE,mBAAmB,EAAE;AACvD,kBAAkB,kBAAkB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;AAChG,gBAAgB,kBAAkB,EAAE;AACpC,gBAAgB,gBAAgB,EAAE;;AAElC;EACE,WAAW,0BAA0B,EAAE;AACzC;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;AAC1C;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,qCAAqC;AACvC;AACA,gBAAgB,eAAe,CAAC,iBAAiB,CAAC,qBAAqB;AACvE;EACE,UAAU,CAAC,WAAW,CAAC,kBAAkB;EACzC,8BAA8B;EAC9B,eAAe,CAAC,cAAc,CAAC,YAAY,CAAC,kBAAkB,CAAC,sBAAsB;AACvF;AACA,eAAe,YAAY;AAC3B,eAAe,YAAY,CAAC,QAAQ,CAAC,sBAAsB;AAC3D;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,uCAAuC;AACzC;AACA,oBAAoB,QAAM;AAC1B,kBAAkB,kBAAkB,CAAC,iBAAiB,CAAC,cAAc;AACrE,gBAAgB,YAAY,CAAC,6CAA6C,CAAC,QAAQ,CAAC,eAAe;AACnG;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,OAAO;EACP,sBAAsB;EACtB,iBAAiB;AACnB;AACA,mBAAmB,eAAe,CAAC,cAAc;AACjD,iBAAiB,eAAe,CAAC,aAAa;AAC9C,iBAAiB,iBAAiB,CAAC,kBAAkB,CAAC,cAAc;AACpE,eAAe,YAAY,CAAC,cAAc,CAAC,OAAO,CAAC,eAAe;AAClE,kBAAkB,eAAe;AACjC,wBAAwB,eAAe,CAAC,iBAAiB,CAAC,kBAAkB;AAC5E,kCAAkC,kBAAkB,CAAC,cAAc;AACnE,mBAAmB,YAAY,CAAC,6CAA6C,CAAC,QAAQ;AACtF,kBAAkB,8BAA8B,CAAC,kBAAkB,CAAC,YAAY;AAChF,wBAAwB,eAAe,CAAC,iBAAiB,CAAC,iBAAiB;AAC3E,uBAAuB,kBAAkB,CAAC,iBAAiB,CAAC,cAAc,CAAC,mBAAmB,CAAC,oBAAoB,CAAC,2BAA2B,CAAC,eAAe;AAC/J,uBAAuB,YAAY,CAAC,OAAO,CAAC,cAAc,CAAC,eAAe;AAC1E,eAAe,8BAA8B,CAAC,mBAAmB,CAAC,gBAAgB,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,eAAe;AACvI;EACE,YAAY,CAAC,kBAAkB,CAAC,sBAAsB;EACtD,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,gBAAgB,6CAA6C;EAC7D,mBAAmB,yBAAyB;EAC5C,mBAAmB,gBAAgB;AACrC","sourcesContent":[".sr-page {\n  min-height: 100vh;\n  background: var(--bg);\n}\n\n/* Header */\n.sr-header {\n  background: #fff;\n  border-bottom: 1px solid var(--border);\n  padding: 20px 20px;\n  position: sticky;\n  top: 64px;\n  z-index: 50;\n}\n\n.sr-header-inner {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.sr-back {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 1px solid var(--border);\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: var(--text);\n  flex-shrink: 0;\n  transition: background 0.2s;\n  text-decoration: none;\n}\n.sr-back:hover { background: var(--bg); }\n\n.sr-search-bar {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: #f3f4f6;\n  border: 1.5px solid var(--border);\n  border-radius: 12px;\n  padding: 8px 10px 8px 14px;\n  transition: border-color 0.2s;\n  max-width: 560px;\n}\n.sr-search-bar:focus-within {\n  border-color: var(--p1);\n  background: #fff;\n}\n.sr-search-bar svg { color: var(--muted2); flex-shrink: 0; }\n.sr-search-bar input {\n  flex: 1;\n  border: none;\n  background: transparent;\n  font-size: 0.95rem;\n  font-family: inherit;\n  color: var(--text);\n  outline: none;\n}\n.sr-search-bar input::placeholder { color: var(--muted2); }\n\n.sr-search-btn {\n  background: var(--grad);\n  color: #fff;\n  border: none;\n  border-radius: 9px;\n  padding: 9px 18px;\n  font-size: 0.88rem;\n  font-weight: 700;\n  cursor: pointer;\n  font-family: inherit;\n  white-space: nowrap;\n  transition: opacity 0.2s;\n}\n.sr-search-btn:hover { opacity: 0.9; }\n\n/* Body */\n.sr-body {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 32px 20px 60px;\n}\n\n.sr-meta {\n  margin-bottom: 24px;\n}\n\n.sr-meta-title {\n  font-size: 1.3rem;\n  font-weight: 800;\n  color: var(--text);\n  letter-spacing: -0.3px;\n}\n\n.sr-meta-sub {\n  font-size: 0.85rem;\n  color: var(--muted);\n  margin-top: 4px;\n}\n\n/* Filters row */\n.sr-filters {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-bottom: 28px;\n}\n\n.sr-filter-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  border: 1.5px solid var(--border);\n  border-radius: 20px;\n  padding: 6px 14px;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--muted);\n  background: #fff;\n  cursor: pointer;\n  transition: border-color 0.2s, color 0.2s;\n}\n.sr-filter-chip:hover, .sr-filter-chip.active {\n  border-color: var(--p1);\n  color: var(--p1);\n}\n\n/* City proximity filter */\n.sr-city-filter {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n}\n\n.sr-city-input-wrap {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n  min-width: 200px;\n  background: #fff;\n  border: 1.5px solid var(--border);\n  border-radius: 10px;\n  padding: 0 10px;\n  transition: border-color 0.2s;\n}\n.sr-city-input-wrap:focus-within {\n  border-color: var(--p1);\n}\n\n.sr-city-icon { color: var(--muted); flex-shrink: 0; }\n\n.sr-city-input {\n  flex: 1;\n  border: none;\n  outline: none;\n  font-size: 0.9rem;\n  color: var(--text);\n  background: transparent;\n  padding: 10px 0;\n  font-family: inherit;\n}\n.sr-city-input::placeholder { color: var(--muted); }\n\n.sr-city-clear {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--muted);\n  display: flex;\n  align-items: center;\n  padding: 2px;\n  border-radius: 50%;\n  transition: color 0.15s;\n}\n.sr-city-clear:hover { color: var(--text); }\n\n.sr-locate-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 16px;\n  border-radius: 10px;\n  border: 1.5px solid var(--p1);\n  background: #fff;\n  color: var(--p1);\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.2s, color 0.2s;\n  font-family: inherit;\n}\n.sr-locate-btn:hover:not(:disabled) { background: var(--p1); color: #fff; }\n.sr-locate-btn:disabled { opacity: 0.6; cursor: not-allowed; }\n\n@keyframes sr-spin { to { transform: rotate(360deg); } }\n.sr-spin { animation: sr-spin 0.8s linear infinite; }\n\n/* Grid */\n.sr-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  gap: 16px;\n}\n\n.sr-card {\n  background: #fff;\n  border: 1px solid var(--border);\n  border-radius: 16px;\n  overflow: hidden;\n  cursor: pointer;\n  text-decoration: none;\n  transition: box-shadow 0.2s, transform 0.15s;\n  padding: 0;\n  width: 100%;\n  text-align: left;\n}\n.sr-card:focus { outline: none; }\n.sr-card:focus-visible { box-shadow: 0 0 0 3px rgba(79,70,229,0.25),0 6px 24px rgba(0,0,0,0.09); }\n.sr-card:hover { box-shadow: 0 6px 24px rgba(0,0,0,0.09); transform: translateY(-2px); }\n\n.sr-card-top {\n  height: 90px;\n  background: linear-gradient(135deg, #eef2ff, #e0e7ff);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.sr-avatar {\n  width: 68px;\n  height: 68px;\n  border-radius: 50%;\n  border: 3px solid #fff;\n  object-fit: cover;\n  position: absolute;\n  bottom: -24px;\n  left: 20px;\n  background: #e0e7ff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.4rem;\n  font-weight: 800;\n  color: var(--p1);\n}\n\n.sr-card-body {\n  padding: 32px 16px 16px;\n}\n\n.sr-name {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--text);\n  margin-bottom: 2px;\n}\n\n.sr-address {\n  font-size: 0.78rem;\n  color: var(--muted);\n  margin-bottom: 10px;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.sr-cats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n  margin-bottom: 12px;\n}\n\n.sr-cat-tag {\n  background: #eef2ff;\n  color: var(--p1);\n  font-size: 0.72rem;\n  font-weight: 700;\n  border-radius: 6px;\n  padding: 3px 8px;\n}\n\n.sr-footer-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-top: 1px solid var(--border);\n  padding-top: 10px;\n}\n\n.sr-rating {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: #f59e0b;\n}\n.sr-rating span { color: var(--muted); font-weight: 500; }\n\n.sr-done {\n  font-size: 0.78rem;\n  color: var(--muted);\n}\n.sr-done strong { color: var(--text); font-weight: 700; }\n\n/* States */\n.sr-loading, .sr-empty {\n  text-align: center;\n  padding: 80px 20px;\n  color: var(--muted);\n}\n\n.sr-spinner {\n  width: 36px;\n  height: 36px;\n  border: 3px solid var(--border);\n  border-top-color: var(--p1);\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n  margin: 0 auto 16px;\n}\n@keyframes spin { to { transform: rotate(360deg); } }\n\n.sr-empty-icon { font-size: 3rem; margin-bottom: 12px; }\n.sr-empty-title { font-size: 1.05rem; font-weight: 700; color: var(--text); margin-bottom: 6px; }\n.sr-empty-sub { font-size: 0.88rem; }\n.sr-empty-cta { margin-top: 24px; }\n\n@media (max-width: 500px) {\n  .sr-grid { grid-template-columns: 1fr; }\n}\n\n.sr-modal-backdrop{\n  position: fixed;\n  inset: 0;\n  background: rgba(17,24,39,0.55);\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 90px 16px 20px;\n  z-index: 120;\n}\n.sr-modal{\n  width: min(860px,100%);\n  background: #fff;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 18px 60px rgba(0,0,0,0.25);\n}\n.sr-modal-head{\n  display:flex;\n  align-items:center;\n  justify-content:space-between;\n  padding:14px 16px;\n  border-bottom:1px solid var(--border);\n}\n.sr-modal-title{font-weight:800;color:var(--text);letter-spacing:-0.2px}\n.sr-modal-close{\n  width:34px;height:34px;border-radius:10px;\n  border:1px solid var(--border);\n  background:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;\n}\n.sr-modal-body{padding:16px}\n.sr-modal-hero{display:flex;gap:14px;align-items:flex-start}\n.sr-modal-avatar .sr-avatar{\n  position: static;\n  width: 78px;\n  height: 78px;\n  border: 2px solid #fff;\n  box-shadow: 0 6px 18px rgba(0,0,0,0.12);\n}\n.sr-modal-hero-meta{flex:1}\n.sr-modal-address{color:var(--muted);font-size:0.85rem;margin-top:2px}\n.sr-modal-stats{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:10px;margin-top:10px}\n.sr-modal-stat{\n  border:1px solid var(--border);\n  border-radius:12px;\n  padding:10px;\n  display:flex;\n  gap:8px;\n  align-items:flex-start;\n  color:var(--text);\n}\n.sr-modal-stat svg{color:var(--p1);margin-top:2px}\n.sr-modal-stat-v{font-weight:800;line-height:1}\n.sr-modal-stat-k{font-size:0.72rem;color:var(--muted);margin-top:3px}\n.sr-modal-cats{display:flex;flex-wrap:wrap;gap:6px;margin-top:12px}\n.sr-modal-section{margin-top:16px}\n.sr-modal-section-title{font-weight:800;color:var(--text);margin-bottom:10px}\n.sr-modal-loading,.sr-modal-empty{color:var(--muted);padding:10px 0}\n.sr-modal-services{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px}\n.sr-modal-service{border:1px solid var(--border);border-radius:12px;padding:12px}\n.sr-modal-service-title{font-weight:800;color:var(--text);font-size:0.92rem}\n.sr-modal-service-desc{color:var(--muted);font-size:0.82rem;margin-top:4px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}\n.sr-modal-service-meta{display:flex;gap:6px;flex-wrap:wrap;margin-top:10px}\n.sr-modal-pill{border:1px solid var(--border);border-radius:999px;padding:4px 10px;font-size:0.72rem;color:var(--muted);background:#fff}\n.sr-modal-cta{\n  display:flex;align-items:center;justify-content:center;\n  margin-top:16px;\n  height:46px;\n  border-radius:12px;\n  background:var(--grad);\n  color:#fff;\n  font-weight:800;\n  text-decoration:none;\n}\n@media (max-width: 760px){\n  .sr-modal-stats{grid-template-columns:repeat(2,minmax(0,1fr))}\n  .sr-modal-services{grid-template-columns:1fr}\n  .sr-modal-backdrop{padding-top:78px}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
